export default "__VITE_ASSET__21472786__"